
export const ValueElement = ({ value }) => {

    let valueArray = [];
    try {
        valueArray = value ? JSON.parse(value ?? "[]") : [];
    } catch (error) {
        console.log(`ValueElement Failed to format value ${value + ""}`)
    }

    return (
        <div>
            {valueArray?.map(v => <div>{v.value ?? ""}</div>)}
        </div>
    )
}